enum OrderFilters {
    OrderNumber = "OrderNumber",
    Status = "Status",
    Channel = "Channel",
    ChannelType = "ChannelType",
    DateFrom = "DateFrom",
    DateTo = "DateTo",
    Sku = "Sku"
}

export default OrderFilters;